// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1luNp","errors":"Errors_errors__3O2Dl"};